import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

// Use the manually uploaded wide logo from public directory
const nivaasLogo = '/nivaas_logo_wide.png';

const Header = ({ 
  activeSection = '', 
  onSectionClick = null, 
  showSectionLinks = true,
  showAuthButtons = true,
  className = '',
  onLogout = null
}) => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check localStorage for token on component mount or refresh
    const token = localStorage.getItem('token'); // Replace 'token' with your token key if different
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      logout();
      localStorage.removeItem('token');
      navigate('/landing');
    }
    setMenuOpen(false);
    setIsLoggedIn(false);
  };

  const handleSectionClick = (sectionId) => {
    if (onSectionClick) {
      onSectionClick(sectionId);
    } else {
      // Default behavior for section navigation
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 80,
          behavior: 'smooth'
        });
      }
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`modern-nav ${className}`}>
      <div className="nav-container">
        <div 
          className="nav-brand"
          onClick={() => handleSectionClick('home')}
        >
          <img src={nivaasLogo} alt="Nivaas" className="nav-logo" />
        </div>
        <div className='nav-links-container'>   
        {/* Desktop links */}
        {showSectionLinks && (
          <div className='lg-screen-menus'>
            <div className="nav-links">
              <a 
                href="#home" 
                className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                onClick={(e) => { e.preventDefault(); handleSectionClick('home'); }}
              >
                Home
              </a>
              <a 
                href="#features" 
                className={`nav-link ${activeSection === 'features' ? 'active' : ''}`}
                onClick={(e) => { e.preventDefault(); handleSectionClick('features'); }}
              >
                Features
              </a>
              <a 
                href="#testimonials" 
                className={`nav-link ${activeSection === 'testimonials' ? 'active' : ''}`}
                onClick={(e) => { e.preventDefault(); handleSectionClick('testimonials'); }}
              >
                Reviews
              </a>
              <a 
                href="#pricing" 
                className={`nav-link ${activeSection === 'pricing' ? 'active' : ''}`}
                onClick={(e) => { e.preventDefault(); handleSectionClick('pricing'); }}
              >
                Pricing
              </a>
              <Link to="/contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}>Contact Us</Link>
            </div>
          </div>
        )}
        
        {showAuthButtons && (
          <div className='auth-nav-actions-lg'>
            <div className="nav-actions">
              {isLoggedIn ? (
                <>
                <button onClick={() => navigate('/login')} className="btn-primary">Dashboard</button>
                <button onClick={handleLogout} className="btn-primary">Logout</button>
                </>
              ) : (
                <>
                  <Link to="/login" className="btn-primary">Sign In</Link>
                  <Link to="/register" className="btn-secondary">Get Started</Link>
                </>
              )}
            </div>

            {/* Hamburger icon */}
            <div className="hamburgerMenu" onClick={() => setMenuOpen(!menuOpen)}>
              <i className="fas fa-bars fa-lg"></i>
            </div>
          </div>
        )}
        </div>
      </div>

      {/* Overlay mobile menu */}
      <div className={`overlay-menu ${menuOpen ? 'active' : ''}`}>
        <div className="overlay-content">
          {/* Close icon */}
          <div className="overlay-close" onClick={() => setMenuOpen(false)}>
            <i className="fas fa-times fa-lg"></i>
          </div>
          {showSectionLinks && (
            <>
              <div className="nav-links">
                <a 
                  href="#home" 
                  className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                  onClick={(e) => { e.preventDefault(); handleSectionClick('home'); }}
                >
                  Home
                </a>
                <a 
                  href="#features" 
                  className={`nav-link ${activeSection === 'features' ? 'active' : ''}`}
                  onClick={(e) => { e.preventDefault(); handleSectionClick('features'); }}
                >
                  Features
                </a>
                <a 
                  href="#pricing" 
                  className={`nav-link ${activeSection === 'pricing' ? 'active' : ''}`}
                  onClick={(e) => { e.preventDefault(); handleSectionClick('pricing'); }}
                >
                  Pricing
                </a>
                <a 
                  href="#testimonials" 
                  className={`nav-link ${activeSection === 'testimonials' ? 'active' : ''}`}
                  onClick={(e) => { e.preventDefault(); handleSectionClick('testimonials'); }}
                >
                  Reviews
                </a>
                <Link to="/contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}>Contact Us</Link>
              </div>
            </>
          )}
          {showAuthButtons && (
            <div className='auth-nav-actions-sm'>
              <div className="nav-actions">
                {isLoggedIn ? (
                  <>
                  <button onClick={() => navigate('/login')} className="btn-primary">Dashboard</button>
                  <button onClick={handleLogout} className="btn-primary">Logout</button>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="btn-primary">Sign In</Link>
                    <Link to="/register" className="btn-primary">Get Started</Link>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header; 